import { useState, useEffect, useContext } from "react";
import { DataFormContext } from "./DataFormContext";
// request hook封装, 传入请求方法和请求参数，内部维护loading，error，data
export const useRequest = (fn, params = {}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);

  async function fetchData () {
    setLoading(true);
    setData(null);
    setError(null);
    try {
      const res = await fn(params);
      setData(res);
    } catch (e) {
      setError(e);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    loading,
    data,
    error
  };
};

export const useWindowWidth = () => {
  const [width, setwidth] = useState(0);
  useEffect(() => {
    setwidth(document.documentElement.clientWidth);
  }, []);
  useEffect(() => {
    const debounce = (fn, delay) => {
      let timer = null;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn.apply(this, arguments);
        }, delay);
      };
    };
    const handleResize = debounce(() => {
      setwidth(document.documentElement.clientWidth);
    }, 100);
    // TODO防抖
    window.addEventListener("resize", handleResize, false);
    return () => {
      window.removeEventListener("resize", handleResize, false);
    };
  }, []);
  return [width];
};

export function useFormInstance () {
  const { formRef } = useContext(DataFormContext);
  // return useContext(DataFormContext);
  return formRef;
}

// export function useItemsInstance() {
//   const { itemRef } = React.useContext(DataFormContext);
//   const cacheRef = React.useRef({});

//   function getRef(name, children) {
//     const childrenRef =
//       children && typeof children === "object" && children.ref;
//     const nameStr = name.join("_");
//     if (
//       cacheRef.current.name !== nameStr ||
//       cacheRef.current.originRef !== childrenRef
//     ) {
//       cacheRef.current.name = nameStr;
//       cacheRef.current.originRef = childrenRef;
//       cacheRef.current.ref = composeRef(itemRef(name), childrenRef);
//     }

//     return cacheRef.current.ref;
//   }

//   return getRef;
// }
